import SpreadsheetEditorInsertImageButton from './SpreadsheetEditorInsertImagebutton';

export default SpreadsheetEditorInsertImageButton;